import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "store/store";

export const selectExpandedIds = (state: RootState) =>
  state.routesList.expandedIds;

export const selectIsLoading = (state: RootState) =>
  state.routesList.isLoading ?? false;

export const selectUsersRoutes = (state: RootState) => state.routesList.list;

export const selectRoutesListFilters = (state: RootState) =>
  state.routesList.filters;

export const selectRouteResponse =
  (requestID: string) => (state: RootState) => {
    return state.routesList.list.find((route) => route.id === requestID);
  };

export const selectRoutesTotalCount = (state: RootState) =>
  state.routesList.totalCount;

export const selectIsAuthModalVisible = (state: RootState) =>
  state.routesList.isAuthModalVisible;

export const selectActiveListIndex = createSelector(
  [
    (state: RootState) => state.routesList.activeListIndexes,
    (state: RootState, requestID: string) => requestID,
    (state: RootState, requestID: string, dayIndex: number) => dayIndex,
  ],
  (activeListIndexes, requestID, dayIndex) => {
    const activeList = activeListIndexes[requestID] ?? {};
    const listIndex = activeList[dayIndex] ?? 0;
    return listIndex;
  }
);
